import React, { useState, useLocation, useEffect, useContext } from 'react';
import email_icon from '../Assets/email_icon.png';
import user_icon from '../Assets/user_icon.png';
import './LoginSignup.css'; 
import { Helmet } from 'react-helmet';
import axiosInstance from '../../../axiosInstance'; 
import { UserContext } from '../../../UserContext'; 
import Validation from './LoginSignupValidation';
import { Link, useNavigate } from 'react-router-dom';
import UserEmail from '../UserEmail'; 
import Mount from '../Mount';
import AlertBanner from '../Banner/AlertBanner';


const API_URL = process.env.REACT_APP_API_URL;


const LoginSignup = () => { 
  const navigate = useNavigate();
  const { username, setUser, user, email, setUsername, setEmail, isStudent,  viewState, setViewState, quizFinished, setQuizFinished} = useContext(UserContext);
  
  
  const [action, setAction] = useState("Account Access");
  const [accountType, setAccountType] = useState(
    sessionStorage.getItem('accountType') || 'user'
  );
  const [errors, setErrors] = useState({});
  const [isPasted, setIsPasted] = useState(false);
  const [loading, setLoading] = useState(false); 

  const [successMessage, setSuccessMessage] = useState(''); 
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  

  const handleUsernameChange = (e) => {
    setUsername(e.target.value)
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
  };
  const handleEmailPaste = (e) => {
    e.preventDefault(); 
    setIsPasted(true);
    alert('Please type your primary email address.');

    // Disable autofill dynamically
    setTimeout(() => {
      e.target.setAttribute("autocomplete", "off");
    }, 1000);
  };


  const handleLoginClick = async () => {
    if (loading) return; 
    setLoading(true);
    setShowAlert(false);
    setSuccessMessage(''); 

    if (action === "Login" && email) {
        const values = { 
          email: `${email}`
        };
        try {
            const res = await axiosInstance.post(`${API_URL}/users/enter`, values, { withCredentials: true });
            if (res.data.ok) {
                alert('Magic link sent to your email.');
            } else {
                alert(res.data.message);
            }
        } catch (err) {
            console.error('Error logging in:', err);
            setShowAlert(true); 
            if (err.response && err.response.data && err.response.data.error) {
                alert(err.response.data.error);
            } else {
                alert('An unexpected error occurred');
            }
        }
    }

    setLoading(false);
    setAction("Login");
  };
 
   
  const handleSignupClick = async () => { 
    const userRole = isStudent ? 'student' : 'user'; // Determine role based on isStudent

    const updatedUser = {role: userRole }; // Keep existing user properties intact

    setUser(updatedUser);
    if (loading) return;
    setLoading(true);
    setShowAlert(false);
    setSuccessMessage("");

    if (action === "Account Access") {
        if (!username || !email) {
            setErrors({
                username: !username ? "Username is required" : "",
                email: !email ? "Email is required" : "",
            });
            setLoading(false);
            return;
        }

        const values = { 
            username, 
            email,
            role: user.role
        };
        const validationErrors = Validation(values);
        setErrors(validationErrors);

        const hasValidationErrors = Object.values(validationErrors).some(error => error !== "");

        if (hasValidationErrors) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        setEmail(email);
        setUsername(username);

       
    }

    setLoading(false);
  };

  const handleFormKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) return;

    // Get role from sessionStorage if available
    const role = sessionStorage.getItem('accountType') || 'user';
    
    // Store in localStorage for persistence across redirects
    localStorage.setItem('accountType', role);

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams({
      client_id: clientId,
      redirect_uri: `${window.location.origin}/enter`,
      response_type: 'code',
      scope: 'openid email profile',
      state: role, // Pass the role in state
      prompt: 'select_account'
    })}`;

    window.location.href = authUrl;
  };

  // Clean up on unmount
  useEffect(() => {
    return () => {
      sessionStorage.removeItem('accountType');
    };
  }, []);



  const handleGoBack = () => {
    // Update state to trigger the score confirmation view
    setQuizFinished(true);
    setViewState('scoreConfirmation');

    // Navigate back to the quiz component
    navigate('/sat-hook'); // Replace '/quiz' with the actual route of your quiz component
  };

  useEffect(() => {
    const handleBackNavigation = () => {
      // Clear the message from context
    
      
      // Force forward navigation
      navigate('/login-signup', { replace: true });
    };
  
    // Set up the back navigation blocker
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handleBackNavigation);
  
    return () => {
      window.removeEventListener('popstate', handleBackNavigation);
    };
  }, [navigate]);

  const isPrerendering = typeof window === 'undefined' || window.__PRERENDERING;
  if (typeof window === 'undefined' || isPrerendering) {
    return isPrerendering ? <div id="prerender-placeholder"></div> : null;
  }


  return (
    <div className="setter">
      <Helmet>
        <title>{action === "Login" ? "Login" : "Account Access"} | Contranorm Media & Production</title>
      </Helmet>
      <Mount>
        <div className="page">
          <h1>
              <div className="text">{action}</div>
          </h1>
          <div className="underline"></div>
            
            {successMessage && (
              <div className="success-message">
                {successMessage}
              </div>
            )}
            <>
              <form action="" onClick={handleFormKeyPress}>
                <div className="opino">
                  {action === "Login" ? (
                    <div></div>
                  ) : (
                  <div className="input-with-icon">
                    {errors.username && <span className="text-danger">{errors.username}</span>}
                    <img src={user_icon} id="user_icon" alt="User" className="input-icon" />
                    <input
                      type="text"
                      placeholder="Full Legal Name"
                      value={username}
                      onChange={handleUsernameChange}
                    />
                    
                  </div>
                  )}

                  <div className="input-with-icon">
                    {errors.email && <span className="text-danger">{errors.email}</span>}
                    <img src={email_icon} id="email_icon" alt="Email" className="input-icon" />
                    <UserEmail
                      userEmail={email}
                      enterEmail={handleEmailChange}
                      handleEmailPaste={handleEmailPaste}
                    />
                    
                  </div>
                </div>
              </form>
              <div className="submit-options">
                <div className="submit-container">
                  {isStudent ? (
                    <>
                      <div className="submit gray" onClick={handleGoBack}>Back</div>
                      <div className="submit" onClick={handleGoogleLogin}>Continue</div>
                    </>
                  ) : (
                    <>
                      {action === "Login" ? (
                        <div className="submit gray" onClick={handleGoogleLogin}>Sign Up</div>
                      ) : (
                        <div className="submit" onClick={handleGoogleLogin}>Sign Up</div>
                      )}

                      {action === "Account Access" ? (
                        <div className="submit gray" onClick={handleGoogleLogin}>Login</div>
                      ) : (
                        <div className="submit" onClick={handleGoogleLogin}>Login</div>
                      )}
                      

                      
                    </>
                  )}

                </div>
                {action !== "Account Access" && (
                        <div className="log-link-text">
                          <a
                            href="https://compliance.contranormdigital.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms & Conditions
                          </a>
                        </div>
                      )}

                      {action !== "Login" && (
                        <div className="log-link-text">
                          <a
                            href="https://compliance.contranormdigital.com/privacy-policy/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </a>
                        </div>
                      )}
                
              </div>
              
            </>
           
              
                   

          </div>
        </Mount>
        <AlertBanner 
          showAlert={showAlert} 
          showSaveButton={false} 
          handleCancel={() => setShowAlert(false)}>
          <div style={{ display: 'flex',  width: '100%' }}>
            <span style={{ flex: 1 }}>It appears that you may be in a geo-restricted area or this feature has been temporarily disabled by your device.</span>
          </div>
        </AlertBanner>
    </div>
    
  );
}

export default LoginSignup;